<script setup lang="ts" generic="RadioValue">
import YscInputRadioRaw from './YscInputRadioRaw.vue'
import { defineModel, defineOptions } from '#imports'

interface Props {
  isBlock?: boolean
  isSelectionOverflow?: boolean
  disabled?: boolean
  class?: any
}

const [modelValue, modifiers] = defineModel<RadioValue>()

const props = withDefaults(defineProps<Props>(), {
  isBlock: false,
  isSelectionOverflow: false,
  disabled: false,
  class: undefined,
})

defineOptions({ inheritAttrs: false })
</script>

<template>
  <label :class="[props.class, props.isBlock ? 'flex' : 'inline-flex', props.disabled ? 'cursor-not-allowed' : 'hover:cursor-pointer']">
    <YscInputRadioRaw
      v-model="modelValue"
      v-bind="$attrs"
      :model-modifiers="modifiers"
      :disabled="props.disabled"
      class="peer mr-2 shrink-0"
    />
    <span
      v-if="$slots.default"
      :class="{ 'text-gray-400': props.disabled, 'w-full': isBlock }"
    ><slot /></span>
    <span
      v-if="props.isSelectionOverflow"
      class="absolute inset-0"
      aria-hidden="true"
    />
  </label>
</template>
